<gen-dynamic-form class="patient-details-wrapper" [formConfig]="_formConfig" [formData]="formData"
                  [listenToDataChange]="listenToDataChange"
                  [submitted]="widgetFormInstanceSubmitted"
                  [popupMode]="true"
                  (formChange)="formreplace($event.form)"></gen-dynamic-form>

